import { combineReducers } from '@reduxjs/toolkit';
import { featureFlagsReducer } from './reducers/feature-flags-reducer';
import type { IFeatureFlagsModuleState } from './interfaces';

export default combineReducers<IFeatureFlagsModuleState>({
  featureFlagsReducer
});
